import svg from '../js/svg';
import comp from '../components/barrel';
import U from '../js/utils';

export default {
  application_uuid: null,
  estateEntries: null,
  estateCats: null,
  async prepare() {
    this.application_uuid = thsPage.vars.application_uuid;

    const vars = {};
    vars.application_uuid = this.application_uuid;
    this.recipe.methods.push(await O.mPOST('application/get-estate-detail', vars));
    this.recipe.methods.push(await O.mPOST('application/get-app-summary', vars));
    this.recipe.methods.push(await O.mPOST('communal/estates', vars));
  },
  async render() {
    const rec = this.recipe.methods;

    let data = {};
    if (rec.length) {
      data = await O.PREP(rec);
    }
    await this.loadPage(data);
  },
  async loadPage(data) {
    const detail = data['application/get-estate-detail'].data;
    const estates = data['communal/estates'].data;

    const summaryResponse = data['application/get-app-summary'].data;
    // Handle both array and object response structures
    const summary = Array.isArray(summaryResponse) ? summaryResponse[0] : summaryResponse;
    
    if (!summary) {
      return;
    }
    
    await this.buildFrame({estates, summary});
    await this.populateData({detail});
    this.estateEntries = {detail};
    this.estateCats = {estates};
    this.summary = summary; // Store summary for later use
  },
  async buildFrame({estates, summary}) {
    const {
      party1_user_uuid, party1_full_name,
      party2_user_uuid, party2_full_name,
      party3_user_uuid, party3_full_name,
      party4_user_uuid, party4_full_name,
      party5_user_uuid, party5_full_name
    } = summary;
    
    // Build array of all parties that exist
    let partyArr = [];
    if (party1_user_uuid && party1_full_name) {
      partyArr.push({user_uuid: party1_user_uuid, full_name: party1_full_name});
    }
    if (party2_user_uuid && party2_full_name) {
      partyArr.push({user_uuid: party2_user_uuid, full_name: party2_full_name});
    }
    if (party3_user_uuid && party3_full_name) {
      partyArr.push({user_uuid: party3_user_uuid, full_name: party3_full_name});
    }
    if (party4_user_uuid && party4_full_name) {
      partyArr.push({user_uuid: party4_user_uuid, full_name: party4_full_name});
    }
    if (party5_user_uuid && party5_full_name) {
      partyArr.push({user_uuid: party5_user_uuid, full_name: party5_full_name});
    }
    
    let main_estate = U.id(`main_estate`);
    let cntr = 0;

    for (let party of partyArr) {
      const divMain = U.divAtt('div', 'class', 'card mb-8');
      divMain.id = `party${++cntr}_accordion`;
      
      // Create accordion header
      const header = U.divAtt('div', 'class', 'flex justify-between cursor-pointer');
      header.setAttribute('onclick', `thsSubTab.togglePartyAccordion('party${cntr}')`);
      const heading = U.divAtt('h5');
      heading.innerHTML = `Party ${cntr} - ${party.full_name}`;
      const arrow = await svg.chevronUp(`party${cntr}_arrow`);
      arrow.classList.add('arrowDown'); // Start with arrow pointing down (collapsed)
      header.appendChild(heading);
      header.appendChild(arrow);
      divMain.appendChild(header);
      
      // Create accordion content div (hidden by default)
      const contentDiv = U.divAtt('div', 'id', `party${cntr}_content`);
      contentDiv.classList.add('hide'); // Start hidden
      const hr = U.divAtt('hr', 'class', 'mb-8');
      contentDiv.appendChild(hr);

      for (let estate of estates) {
        const div = U.divAtt('div', 'class', 'mb-10');
        const h5 = U.divAtt('h5');
        h5.innerHTML = estate.short_text;

        const table = U.divAtt('table', 'id', `${party.user_uuid}_${estate.estate_uuid}`);
        table.classList.add('hide'); // Hide the table to start with
        const thead = U.divAtt('thead');
        const headRow = thead.insertRow();
        const descH = headRow.insertCell(0);
        descH.innerHTML = 'Description';
        const assH = headRow.insertCell(1);
        assH.innerHTML = 'Asset Rand Value';
        const liabH = headRow.insertCell(2);
        liabH.innerHTML = 'Liability Rand Value';
        const shareH = headRow.insertCell(3);
        shareH.innerHTML = 'Percentage of Share';
        const editH = headRow.insertCell(4);
        editH.innerHTML = 'Edit';
        const removeH = headRow.insertCell(5);
        removeH.innerHTML = 'Remove';

        const tbody = U.divAtt('tbody', 'id', `${estate.estate_uuid}_${party.user_uuid}`);

        thead.appendChild(headRow);
        table.appendChild(thead);
        table.appendChild(tbody);

        const addButt = U.divAtt('button');
        addButt.innerHTML = '+ Add Item';
        addButt.setAttribute('onclick', `thsSubTab.addItem('${estate.estate_uuid}','${party.user_uuid}','${estate.short_text}','Party ${cntr} - ${party.full_name}')`);

        div.appendChild(h5);
        div.appendChild(table);
        div.appendChild(addButt);
        contentDiv.appendChild(div);
      }
      
      divMain.appendChild(contentDiv);
      main_estate.appendChild(divMain);
    }
  },
  async populateData({detail}) {
    for (let row of detail) {
      const tbody = U.id(`${row.dd_estate_uuid}_${row.testator_uuid}`);
      const estateRow = tbody.insertRow();

      const desc = estateRow.insertCell(0);
      desc.innerHTML = `${row.estate_desc}`;
      const ass_val = estateRow.insertCell(1);
      ass_val.innerHTML = U.formatNumberWithThousands(row.ass_val);
      const liab_val = estateRow.insertCell(2);
      liab_val.innerHTML = U.formatNumberWithThousands(row.liab_val);
      const share_val = estateRow.insertCell(3);
      share_val.innerHTML = row.share_val !== null ? row.share_val : 'not applicable';

      const editIcon = estateRow.insertCell(4);
      const edit_onclick = `thsSubTab.fetchEditItem('${row.application_estate_uuid}')`;
      const editSVG = svg.edit(edit_onclick);
      editIcon.appendChild(editSVG);

      const removeIcon = estateRow.insertCell(5);
      const onclick = `thsSubTab.removeItem('${row.application_estate_uuid}')`;
      const linkSVG = svg.trash(onclick);
      removeIcon.appendChild(linkSVG);

      tbody.appendChild(estateRow);
      U.unhide(`${row.testator_uuid}_${row.dd_estate_uuid}`);
    }
  },
  async removeItem(application_estate_uuid) {
    const vars = {};
    vars.application_estate_uuid = application_estate_uuid;

    O.PREP([await O.mPOST('application/rmv-estate-detail', vars)])
      .then(async (res) => {
        comp.toast(res['application/rmv-estate-detail'].status);
        O.changeSubTab('ADs_Equity');
      })
      .catch(() => {});
  },
  async addItem(estate_uuid, user_uuid, short_text, partyName) {
    const formHTML = await this.buildItemForm(short_text);
    const form = formHTML.outerHTML;

    const div = `
      <div
        id="itemBox"
        class="fixed inset-0 z-20 overflow-y-auto bg-opacity-50 bg-black ">

        <div class="card relative transform overflow-hidden">
        <h4 style="font-weight: 600; color: #000; margin-bottom: 0.5rem;">${short_text}</h4>
        <h4>Add new item - ${partyName}</h4>

        <div id="newItem">
        ${form}
        </div>

        <div
        class="flex justify-center items-center" >
        <button class="btn-outline mr-4" onclick="U.closeModal('itemBox')">Cancel</button>
        <button id="updPass-btn" onclick="thsSubTab.submitNewItem('${estate_uuid}', '${user_uuid}')">Add item</button>

      </div>`;

    const passBox = U.createHTMLElementFromString(div);
    document.body.prepend(passBox);
    this.attachThousandsFormatting('itemBox');
  },
  attachThousandsFormatting(containerId) {
    const assInput = U.id('item_ass');
    const liabInput = U.id('item_liab');
    if (assInput) {
      assInput.addEventListener('input', (e) => {
        const raw = U.parseFormattedNumber(e.target.value);
        e.target.value = raw ? U.formatNumberWithThousands(raw) : '';
      });
    }
    if (liabInput) {
      liabInput.addEventListener('input', (e) => {
        const raw = U.parseFormattedNumber(e.target.value);
        e.target.value = raw ? U.formatNumberWithThousands(raw) : '';
      });
    }
  },
  async buildItemForm(short_text, editData) {
    const div = U.divAtt('div', 'class', '');
    const grid1 = U.divAtt('div', 'class', 'res-grid-cols-1');
    const grid2 = U.divAtt('div', 'class', 'res-grid-cols-2');
    const title = U.divAtt('h6', 'class', 'text-primary');
    title.innerHTML = `Item Information`;

    let item_desc = await comp.inputText(`item_desc`, editData?.estate_desc || '', 'Description', 1);
    let item_ass = await comp.inputNumber(`item_ass`, editData?.ass_val || '', 'Asset Rand Value ', 0, true);
    let item_liab = await comp.inputNumber(`item_liab`, editData?.liab_val || '', 'Liability Rand Value ', 0, true);
    let item_share = await comp.inputNumber(`item_share`, editData?.share_val || '', 'Percentage of Share', 0);

    grid1.appendChild(item_desc);
    grid2.appendChild(item_ass);
    grid2.appendChild(item_liab);
    if (short_text == 'Fixed Property' || short_text == 'Business' || short_text == 'Life insurance payable to estate' 
      || short_text == 'Other'  || short_text == 'Cash/Shares/Investments' || short_text == 'Movable property (including vehicles)' || short_text == 'Policies not payable  to estate (annuity, policies  with named beneficiaries)')
 {
      grid2.appendChild(item_share);
    }

    div.appendChild(grid1);
    div.appendChild(grid2);

    return div;
  },
  async submitNewItem(estate_uuid, user_uuid) {
    let isValid = await U.validateForm('newItem');
    if (!isValid) {
      return;
    }

    const vars = {};
    vars.application_uuid = this.application_uuid;
    vars.testator_uuid = user_uuid;
    vars.estate_uuid = estate_uuid;
    vars.estate_desc = U.id('item_desc').value;
    vars.ass_val = U.parseFormattedNumber(U.id('item_ass').value) || 0;
    vars.liab_val = U.parseFormattedNumber(U.id('item_liab').value) || 0;
    vars.share_val = U.id('item_share') ? U.id('item_share').value || 0 : null;

    if (!vars.ass_val && !vars.liab_val) {
      U.id('item_ass').classList.add('input-error');
      U.id('item_liab').classList.add('input-error');

      const msg = 'Please note that a value for either Asset Rand Value or Liability Rand Value is required.';
      comp.errorBox('Missing input', msg);
      return;
    }

    O.PREP([await O.mPOST('application/ins-estate-detail', vars)])
      .then(async (res) => {
        U.closeModal('itemBox');
        const newItemData = res['application/ins-estate-detail'].data;
        comp.toast(res['application/ins-estate-detail'].status);

        O.changeSubTab('ADs_Equity');
      })
      .catch(() => {});
  },
  async fetchEditItem(app_estate_uuid) {
    const result = this.estateEntries.detail.find((item) => item.application_estate_uuid === app_estate_uuid);
    const estate = this.estateCats.estates.find((item) => item.estate_uuid === result.dd_estate_uuid);
    
    // Use stored summary data instead of making another API call
    const summary = this.summary;
    if (!summary) {
      return;
    }
    
    let partyName = '';
    // Check all parties (party1 through party5)
    if (result.testator_uuid === summary.party1_user_uuid) {
      partyName = `Party 1 - ${summary.party1_full_name}`;
    } else if (result.testator_uuid === summary.party2_user_uuid) {
      partyName = `Party 2 - ${summary.party2_full_name}`;
    } else if (result.testator_uuid === summary.party3_user_uuid) {
      partyName = `Party 3 - ${summary.party3_full_name}`;
    } else if (result.testator_uuid === summary.party4_user_uuid) {
      partyName = `Party 4 - ${summary.party4_full_name}`;
    } else if (result.testator_uuid === summary.party5_user_uuid) {
      partyName = `Party 5 - ${summary.party5_full_name}`;
    } else {
      // Fallback if party not found
      partyName = `Party - ${result.testator_uuid}`;
    }

    this.editItem(result.dd_estate_uuid, estate.short_text, result, partyName);
  },
  async editItem(estate_uuid, short_text, editData, partyName) {
    const formHTML = await this.buildItemForm(short_text, editData);
    const form = formHTML.outerHTML;

    const div = `
      <div
        id="itemBox"
        class="fixed inset-0 z-20 overflow-y-auto bg-opacity-50 bg-black ">

        <div class="card relative transform overflow-hidden">
        <h4 style="font-weight: 600; color: #000; margin-bottom: 0.5rem;">${short_text}</h4>
        <h4>Edit item - ${partyName}</h4>

        <div id="newItem">
        ${form}
        </div>

        <div
        class="flex justify-center items-center" >
        <button class="btn-outline mr-4" onclick="U.closeModal('itemBox')">Cancel</button>
        <button id="updPass-btn" onclick="thsSubTab.submitEditItem('${estate_uuid}', '${editData.application_estate_uuid}', '${editData.testator_uuid}')">Edit item</button>

      </div>`;

    const passBox = U.createHTMLElementFromString(div);
    document.body.prepend(passBox);
    this.attachThousandsFormatting('itemBox');
  },
  async submitEditItem(estate_uuid, application_estate_uuid, testator_uuid) {
    let isValid = await U.validateForm('newItem');
    if (!isValid) {
      return;
    }

    const vars = {};
    vars.application_estate_uuid = application_estate_uuid;
    vars.application_uuid = this.application_uuid;
    vars.testator_uuid = testator_uuid;
    vars.estate_uuid = estate_uuid;
    vars.estate_desc = U.id('item_desc').value;
    vars.ass_val = U.parseFormattedNumber(U.id('item_ass').value) || 0;
    vars.liab_val = U.parseFormattedNumber(U.id('item_liab').value) || 0;
    vars.share_val = U.id('item_share') ? U.id('item_share').value || 0 : null;

    if (!vars.ass_val && !vars.liab_val) {
      U.id('item_ass').classList.add('input-error');
      U.id('item_liab').classList.add('input-error');

      const msg = 'Please note that a value for either Asset Rand Value or Liability Rand Value is required.';
      comp.errorBox('Missing input', msg);
      return;
    }

    O.PREP([await O.mPOST('application/upd-estate-detail', vars)])
      .then(async (res) => {
        U.closeModal('itemBox');
        const newItemData = res['application/upd-estate-detail'].data;
        comp.toast(res['application/upd-estate-detail'].status);

        O.changeSubTab('ADs_Equity');
      })
      .catch(() => {});
  },
  async savePage(nextPrev) {
    const method = 'application/val-app-page';
    const vars = {};
    vars.application_uuid = this.application_uuid;
    vars.page_name = 'ADs_Equity';
    O.PREP([await O.mPOST(method, vars)])
      .then(async (res) => {
        comp.toast(res[method].status);
        const pageData = res[method].data;

        if (nextPrev === 'next_page') {
          thsPage.pageProgress(pageData);
          await thsPage.goToMainTab('Will draft');
          return;
        }

        thsPage.pageProgress(pageData, nextPrev);
      })
      .catch(() => {});
  },
  async togglePartyAccordion(partyId) {
    const contentDiv = U.id(`${partyId}_content`);
    const arrow = U.id(`${partyId}_arrow`);
    
    if (contentDiv.classList.contains('hide')) {
      // Expand accordion
      U.unhide(`${partyId}_content`);
      arrow.classList.remove('arrowDown');
    } else {
      // Collapse accordion
      U.hide(`${partyId}_content`);
      arrow.classList.add('arrowDown');
    }
  },
};
